import { chatApi } from '../chatApi';
import { useApiConfig } from './useApiConfig';

export const useChatApi = () => {
  const config = useApiConfig();

  return chatApi(config);
};
